import { Avatar, CardContent, Card, Box } from '@mui/material';
import SvgIconStyle from 'src/components/SvgIconStyle';
import styled from 'styled-components';

export const StyledSvgIconStyle = styled(SvgIconStyle)({
  width: 80,
  height: 36,
  zIndex: 9,
  bottom: -15,
  position: 'absolute',
  color: 'background.paper',
});

export const StyledAvatar = styled(Avatar)({
  left: 24,
  zIndex: 9,
  width: 32,
  height: 32,
  bottom: -16,
  position: 'absolute',
});
export const StyledCardContent = styled(CardContent)({
  pt: 4.5,
 
});
export const StyledCardContainer = styled(Card)({
  marginBottom: '20px',
  marginRight: '15px',
    marginLeft: '15px',
  cursor:'pointer'
});
export const StyledModalBox = styled(Box)({
  width: '50%',
  height: '97%',
  margin: '1%',
  background: 'white',
  padding: '20px',
  borderRadius: '20px',
});
export const StyledDeleteCard = styled(Card)({
  top: '40%',
  width: '500px',
  left: '35%',
  right: '35%',
  padding: 25,
});